module.exports = __webpack_public_path__ + "img/circle_pause.b967395c.png";